import { useEnv } from '@sparklayer-io/spark-dash-core/context/env-context';
import { useSite } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { useQuery } from '@tanstack/react-query';
import { supportsMetafields } from '../constants';
import type { MetafieldGroup } from '../types';
import { usePlatformApi } from './use-platform-api';

export const METAFIELD_QUERY_KEY = 'get-metafield-configuration';

export function useMetafieldConfiguration() {
  const { platformApi } = usePlatformApi();
  const site = useSite();
  const env = useEnv();

  return useQuery<MetafieldGroup[]>({
    queryKey: [METAFIELD_QUERY_KEY, site.siteId, site.siteEnv],
    queryFn: () => platformApi.metafieldConfiguration(site.siteId, site.siteEnv),
    enabled: supportsMetafields(env.connected_platform),
  });
}
